<template>
  <div>
    <v-card class="px-5 mb-10">
      <v-row>
        <v-col cols="12" md="11" class="my-auto">
          <h3 class="primary--text">
            PETA JABATAN - {{ unor_name.toUpperCase() }}
          </h3>
        </v-col>

        <MEdit />
      </v-row>
    </v-card>

    <div>
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <v-card outlined>
      <v-card-title>
        Tampilan Hierarki
        <v-spacer />

        <v-btn
          text
          color="primary"
          @click="
            expandAll = !expandAll;
            expandVersion++;
          "
        >
          {{ expandAll ? "Tutup semua" : "Buka semua" }}
        </v-btn>
      </v-card-title>

      <v-divider />

      <div class="tree-viewport">
        <tree-view
          :items="data"
          :options="treeOptions"
          :selected-id="selectedId"
          @select="pilihNode"
        >
          <template v-slot:custom="{ item }">
            <div class="my-1" style="font-size: small">
              <div >
                <strong> {{ item.asn.nama }} </strong>
              </div>

              <div class="font-weight-light">{{ item.asn.nip }}</div>
            </div>

            <div>
              <v-btn
                x-small
                color="primary"
                @click.stop="tambah_asn(item)"
                v-if="item.asn.nip === null || item.asn.nip === undefined"
              >
                <v-icon small left>mdi-account-tie</v-icon>
                Tambah ASN
              </v-btn>

              <v-btn
                class="black--text"
                x-small
                color="warning"
                @click.stop="tambah_asn(item)"
                v-else
              >
                <v-icon small left color="black">mdi-account-tie</v-icon>
                Ubah ASN
              </v-btn>
            </div>
          </template>
        </tree-view>
      </div>
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import TreeView from "@/components/lib/TreeView.vue";
import MEdit from "@/components/anjab/mutasi/edit";

import SAdd from "@/store/anjab/mutasi/add";
import SEdit from "@/store/anjab/mutasi/edit";
import SView from "@/store/anjab/mutasi/view";

export default {
  components: {
    MEdit,
    TreeView,
  },

  data: () => ({
    token: Cookie.get("token"),
    unor_name: localStorage.getItem("unor"),

    ds: {},

    data: [],
    selectedNode: null,
    expandAll: false,
    expandVersion: 0,

    treeOptions: {
      id: "id",
      label: "namaJabatan",
      children: "bawahan",
      subtitle: "",
      description: "",
      icon: "",
      defaultExpandedDepth: 1,
    },
  }),

  computed: {
    refresh: {
      get() {
        return SView.state.refresh;
      },
    },

    alertMassage: {
      get() {
        return SView.state.alertMassage;
      },
    },

    success: {
      get() {
        return SView.state.success;
      },
      set(value) {
        SView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return SView.state.alertBerhasil;
      },
      set(value) {
        SView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return SView.state.alertGagal;
      },
      set(value) {
        SView.commit("gagalAlert", value);
      },
    },
  },

  watch: {
    refresh() {
      this.get_data();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  async mounted() {
    this.get_data();
  },

  methods: {
    get_data() {
      this.ldata = true;

      const url = `${process.env.VUE_APP_API}/petajab/unor/${this.$route.params.id}`;

      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.ldata = false;
          this.ds = this.convert(res.data.mapData[0]);
          this.data = res.data.mapData;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    Ftgl(tgl) {
      const date = new Date(tgl);
      const dateTimeFormat = new Intl.DateTimeFormat("id", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      });
      const formatted = dateTimeFormat.formatToParts(date);
      return (
        formatted[0].value + " " + formatted[2].value + " " + formatted[4].value
      );
    },

    convert(value) {
      const files = JSON.stringify(value);
      var parsed = JSON.parse(files, function (k, v) {
        if (k === "namaJabatan") {
          this.title = v;
        } else if (k === "bawahan") {
          this.children = v;
        } else {
          return v;
        }
      });

      return parsed;
    },

    nodeClick(value) {
      SEdit.commit("TModal", true);
      SEdit.commit("VData", value);
    },

    tambah_asn(value) {
      SEdit.commit("TModal", true);
      SEdit.commit("VData", value);
    },

    addItem() {
      SAdd.commit("TModal", true);
    },
  },
};
</script>
